var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.54445 20.0559V11.9926H7.68042V9.92627H12.1166V20.0559H9.54445Z",
    fill: "#045ED6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7846 12.5427C21.7846 13.4242 21.3078 14.2044 20.513 14.638C21.6256 15.1003 22.3192 16.0686 22.3192 17.1956C22.3192 19.0163 20.7008 20.1724 18.172 20.1724C15.6432 20.1724 14.0248 19.0307 14.0248 17.2391C14.0248 16.083 14.7762 15.1003 15.9467 14.638C15.0941 14.1611 14.545 13.352 14.545 12.4706C14.545 10.852 15.9612 9.82617 18.1576 9.82617C20.3829 9.82617 21.7846 10.881 21.7846 12.5427ZM16.4524 16.979C16.4524 17.8316 17.0594 18.3084 18.172 18.3084C19.2847 18.3084 19.906 17.8461 19.906 16.979C19.906 16.141 19.2847 15.664 18.172 15.664C17.0593 15.664 16.4524 16.1409 16.4524 16.979ZM16.7126 12.6872C16.7126 13.4099 17.2328 13.8143 18.172 13.8143C19.1113 13.8143 19.6315 13.4098 19.6315 12.6872C19.6315 11.936 19.1113 11.5169 18.172 11.5169C17.2327 11.5169 16.7126 11.936 16.7126 12.6872Z",
    fill: "#045ED6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5987 11.0704C27.0263 12.3325 27.2433 13.6526 27.2433 14.9989C27.2433 21.7498 21.7509 27.2422 14.9998 27.2422C8.24872 27.2422 2.75624 21.7498 2.75624 14.9989C2.75624 8.24783 8.24863 2.75566 14.9997 2.75566C16.3463 2.75566 17.6663 2.9724 18.9283 3.40021V0.675619C17.6536 0.326206 16.3371 0.148926 14.9998 0.148926C6.8115 0.148926 0.14975 6.81062 0.14975 14.9989C0.14975 23.1872 6.8115 29.8489 14.9998 29.8489C23.1881 29.8489 29.8497 23.1872 29.8497 14.9989C29.8497 13.6617 29.6726 12.3451 29.3231 11.0704H26.5987Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8577 4.13355V1.28613H23.8102V4.13355H20.9798V6.18089H23.8102V9.02822H25.8577V6.18089H28.705V4.13355H25.8577Z",
    fill: "#045ED6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18);
export default __webpack_public_path__ + "static/media/18+.4c5fe5470fae950afca8afaf4fde6aac.svg";
export { ForwardRef as ReactComponent };